export interface ISupplementCategories {
  id?: number;
  category?: string;
}

export const defaultValue: Readonly<ISupplementCategories> = {};
